import React from 'react';
import { Button } from '../../../../components/Button';
import classes from './section-card.module.scss';

export type SectionCardProps = {
  title: string;
  sectionKey?: string;
  collapsed: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  hideToggle?: boolean;
  titleExtra?: React.ReactNode;
};

export const SectionCard: React.FC<SectionCardProps> = ({ title, sectionKey, collapsed, onToggle, children, hideToggle = false, titleExtra }) => (
  <article className={classes.card}>
    {hideToggle ? null : (
      <Button variant="cancel" className={classes.sectionToggle} onClick={onToggle} dataTestId={sectionKey ? `dashboard-section-toggle-${sectionKey}` : undefined}>
        <span className={classes.sectionToggleChevron} data-open={!collapsed}>{collapsed ? '›' : '⌄'}</span>
        <span className={classes.sectionToggleTitle}>{title}</span>
        {titleExtra ? <span className={classes.sectionToggleExtra}>{titleExtra}</span> : null}
      </Button>
    )}
    {!collapsed ? children : null}
  </article>
);
